/* eslint-disable max-len */

class InformationBoxStore {
  informationBoxData = {};

  constructor() {
    /* Add here information categories */
    this.informationBoxData = {
      houseValue: {
        header: 'Waarde woning',
        text: 'Dit is de (verwachte) aankoopprijs van de woning of (bijvoorbeeld in geval van oversluiten) de marktwaarde van de woning op basis van een gevalideerde taxatie.',
      },
      label: {
        header: 'Verstrekker',
        text: 'Verstrekker is een bank of andere financiële instantie die een lening verstrekt met een woning als onderpand.',
      },
      personalDeposit: {
        header: 'Eigen geld.',
        text: 'Eigen geld is de waarden van het eigen vermogen.',
      },
      mortgage: {
        header: 'Hypotheek',
        text: 'Dit is het bedrag dat u als hypotheeklening nodig heeft om de woning te kunnen kopen. Dit bedrag bestaat uit de aankoopprijs en aanvullende kosten (denk aan notaris, makelaar, adviseur e.d.) verminderd met de inbreng van eigen geld. U kunt maximaal 100% lenen van de waarde van de woning om renteaftrek te kunnen genieten.',
      },
      mortgageType: {
        header: 'Aflosvorm',
        text: 'Lineaire hypotheek:\n' +
          'Bij een lineaire hypotheek lost u elke maand hetzelfde bedrag af. Bovenop dat bedrag komt de hypotheekrente. Doordat u elke maand aflost wordt de hypotheek lager en betaalt u hierdoor elke maand minder rente. Aan het eind van de looptijd heeft u de hypotheek volledig afgelost.\n' +
          '\n' +
          '<br> <br>' +
          'Annuïtaire hypotheek:\n' +
          'U betaalt elke maand hetzelfde bedrag. Alleen de aflossing en de rente veranderen. De eerste jaren betaalt u meer rente dan dan aflossing. Later betaalt u vooral aan de aflossing en minder rente. Aan het einde van de looptijd heeft u de hypotheek volledig afgelost.\n' +
          '\n' +
          '<br> <br>' +
          'Aflossingsvrije hypotheek:\n' +
          'Bij een aflossingsvrije hypotheek betaalt u alleen de rente. De hypotheekschuld blijft gelijk doordat u niet aflost. Aan het einde van de looptijd moet u alsnog de volledige hypotheek aflossen.\n',
      },
      loanPartValue: {
        header: 'Hoogte Leningdeel',
        text: 'De hypotheeklening kan bestaan uit meerdere leningdelen met voor elk deel een eigen aflosvorm, duur, rente en rentevast periode.',
      },
      loanPartDuration: {
        header: 'Looptijd leningdeel',
        text: 'De gehele looptijd van het leningdeel.',
      },
      frtPeriod: {
        header: 'Rentevaste periode',
        text: 'Wanneer u een hypotheek afsluit is de looptijd meestal 30 jaar. Binnen die 30 jaar maakt u een afspraak over de rente die u gaat betalen en voor welke periode. De looptijd van 30 jaar kan opgeknipt worden in meerdere “rentevast periodes”. \n' +
          '\n' +
          '<br> <br>' +
          'De duur van de rentevast periode heeft invloed op de hoogte van de rente. In het algemeen geldt hoe langer die periode is hoger de rente zal zijn. Munt hanteert rentevast periodes van 5, 10, 20 en 30 jaar. Als een rentevast periode afloopt binnen de 30 jaar van de hypotheek, dan moet u een nieuwe “rente afspraak” maken met de dan geldende rente tarieven.\n',
      },
      interest: {
        header: 'Rente',
        text: 'De oorspronkelijke afgesloten rente.',
      },
      nhg: {
        header: 'NHG',
        text: 'Met de Nationale Hypotheek Garantie (NHG) ben je zeker van een verantwoorde en betaalbare hypotheek. Dat beperkt je financiële risico\'s als woningeigenaar - nu, maar ook in de toekomst. Hoeveel je met NHG mag lenen wordt elk jaar opnieuw vastgesteld. Zie www.nhg.nl voor de huidige grens en het tarief. Voor energiebesparende maatregelen mag je extra lenen, boven de marktwaarde.\n',
      },
      initialInterest: {
        header: 'Aanvangsrente',
        text: 'Dit is de hypotheekrente zoals die is afgesproken bij aanvang van de hypotheek.',
      },
      looptijdRente: {
        header: 'Looptijdrente',
        text: 'De looptijdrente is de rente gedurende de gehele looptijd van de hypotheek waarbij de renteopslag automatisch vervalt zodra er voldoende is afgelost. Zodra de hypotheek door aflossen in een lagere risicoklasse valt, verlaagt de geldverstrekker de hypotheekrente.',
      },
      looptijdRenteYesNo: {
        header: 'Looptijdrente',
        text: 'In vergelijkingen met aanbieders die geen looptijdrente hanteren is de aanname gedaan dat de gekozen rente gedurende de rentevaste periode gelijk blijft. Bij het einde van de rentevaste periode wordt de rente aangepast naar de risicoklasse die hoort bij de schuld-marktwaardeverhouding van dat moment (op basis van de periodieke aflossing). Voor de gehele looptijd van de hypotheek (veelal 30 jaar) wordt de oorspronkelijke rentevaste periode gehanteerd (bijvoorbeeld: als gekozen wordt voor een rentevaste periode van 5 jaar dan wordt elke 5 jaar de rente aangepast naar de risicoklasse die hoort bij de schuld-marktwaarde verhouding van dat moment)',
      },
    };
  }
}

const InformationBoxData = new InformationBoxStore();

export default InformationBoxData;
